import { debounce } from 'lodash';
/**
 * Throttles a function to limit the rate at which it can be called.
 *
 * Sample usage:
 * ```javascript
 * constructor(props) {
 *  const { flags } = props;
 *  const enableSearchPerformance = flags['online-cms-search-performance'];
 *  this.debouncedGetNextItems = enableSearchPerformance ? debounceQuery(this.getNextItems) : this.getNextItems;
 * }
 * ```
 *
 * You'll want to cancel the debounce if there's any page navigation
 *
 * ```javascript
 * componentWillUnmount() {
 *  if (this.debouncedGetNextItems.cancel) {
 *    this.debouncedGetNextItems.cancel();
 *  }
 * }
 * ```
 */
export const DEBOUNCE_DELAY_MS = 700;
export const SEARCH_MIN_LENGTH = 3;

export const isValidSearchTerm = (term: string) => {
  return !term || term.length === 0 || term.length >= SEARCH_MIN_LENGTH;
};

export const debounceQuery = (func: (...args: any[]) => any, delay = DEBOUNCE_DELAY_MS) => debounce(func, delay);
